// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__xyeKC","options":"AnswerScale_options__OVIJh","selected":"AnswerScale_selected__3dS6W"};